export enum ContextSource {
  CHANGE_PASSWORD = "ChangePasswordOverlay",
  CHANGE_UNLOCK_KEY = "ChangeUnlockKeyOverlay",
  CONFIGURATIONS = "ConfigurationOverlay",
  GENERIC_OVERLAY = "GenericOverlay",
  IDENTIFY = "IdentifyOverlay",
  NOTIFICATIONS = "NotificationsOverlay", // Currently not used
  IMAGE_VIEW = "ImageViewOverlay",
  ISSUE = "IssueCreateOverlay",
}
